/// <reference types="vite-plugin-svgr/client" />
import { useState, ReactElement } from 'react';
import { useParams, Navigate } from 'react-router';
import styles from './reset-password.page.module.scss';
import { ResetPassword, ResetPasswordSuccess } from '@/me/components';
import { UICard, UISpacer } from '@/ui';
import { RegionSelector } from '@/common/components';
import SafepointLogo from '@/common/assets/images/safepoint-logo-dark.svg?react';

export function ResetPasswordPage(): ReactElement {
    const { token } = useParams();

    const [hasSuccessfullyReset, setHasSuccessfullyReset] = useState(false);

    if (!token) {
        return <Navigate to={'/login'} replace />;
    }

    return (
        <div className={styles.page}>
            <SafepointLogo width={300} />
            <UISpacer multiplier={4} />
            {hasSuccessfullyReset ? (
                <UICard className={styles.card}>
                    <ResetPasswordSuccess />
                </UICard>
            ) : (
                <UICard className={styles.card}>
                    <ResetPassword
                        token={token}
                        onSuccess={() => {
                            setHasSuccessfullyReset(true);
                        }}
                    />
                </UICard>
            )}
            <UISpacer multiplier={1} />
            <RegionSelector variant="compact" />
        </div>
    );
}
